export default __webpack_public_path__ + "static/ntheos-white-b936b92f11f44bff03f09c2913a788e7.png";